/* istanbul ignore file */
/**
 * Dialog component theme configuration.
 */

export const dialog = {
  root: {
    background: '{overlay.modal.background}',
    borderColor: '{overlay.modal.border.color}',
    color: '{overlay.modal.color}',
    borderRadius: '{overlay.modal.border.radius}',
    shadow: '{overlay.modal.shadow}',
  },
  header: {
    padding: '{overlay.modal.padding} {overlay.modal.padding} 0.5rem 1.5rem',
    gap: '0.5rem',
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: '400',
  },
  content: {
    padding: '0 {overlay.modal.padding} {overlay.modal.padding} 1.5rem',
  },
  footer: {
    padding: '0 {overlay.modal.padding} {overlay.modal.padding} 1.5rem',
    gap: '0.5rem',
  },
};
